import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  useColorScheme,
} from "@mui/material";
import bagarasLogo from "../Assets/images/bagaras.jpeg";
import { Menu as MenuIcon } from "@mui/icons-material";
import Link from "@mui/material/Link";
import instaImg from "../Assets/images/Instagram_icon.png";
import fbImg from "../Assets/images/fb.png";
import phoneImg from "../Assets/images/phone-icon.jpg";

const pages: { label: string; href: string }[] = [
  { label: "menu", href: "/order-now" },
  { label: "catering", href: "/catering" },
  { label: "contact", href: "/contact" },
  { label: "franchise", href: "/franchise" },
];
const mobilePages: { label: string; href: string }[] = [
  { label: "home", href: "/home" },
  ...pages,
];

function Header() {
  const [mobileNavOpen, setMobileNavOpen] = React.useState(false);
  const [appBarEl, setAppBarEl] = React.useState<HTMLElement | null>(null);

  React.useLayoutEffect(() => {
    if (!appBarEl) return;
    const root = document.documentElement;
    const update = () => root.style.setProperty("--header-height", `${appBarEl.offsetHeight}px`);
    update();
    const observer = new ResizeObserver(update);
    observer.observe(appBarEl);
    return () => observer.disconnect();
  }, [appBarEl]);

  const handleOpenNavMenu = () => {
    setMobileNavOpen(true);
  };
  const handleCloseNavMenu = () => {
    setMobileNavOpen(false);
  };

  const { mode } = useColorScheme();
  if (!mode) {
    return null;
  }

  return (
    // <div style={{ marginBottom: "1em" }}>
    <div>
      <AppBar ref={setAppBarEl} position="fixed" sx={{ backgroundColor: "#20141e" }}>
        <Container maxWidth="xl">
          <Toolbar disableGutters data-testid="app-toolbar">
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img src={bagarasLogo} alt="Bagara's Indian restaurant logo" width={100} height={80} />
            </Typography>
            <Box
              sx={{
                flexGrow: 1,
                display: { xs: "flex", md: "none" },
                maxWidth: { xs: "100%", md: "50%" },
              }}
            >
              <IconButton
                size="large"
                aria-label="Open navigation menu"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Drawer
                anchor="left"
                open={mobileNavOpen}
                onClose={handleCloseNavMenu}
                sx={{ display: { xs: "block", md: "none" } }}
              >
                <Box
                  sx={{ width: 250, backgroundColor: "#20141e", height: "100%" }}
                  role="navigation"
                  aria-label="Mobile navigation"
                >
                  <List>
                    {mobilePages.map((page) => (
                      <ListItem key={page.label} disablePadding>
                        <ListItemButton
                          component="a"
                          href={page.href}
                          onClick={handleCloseNavMenu}
                          sx={{
                            color: "white",
                            textTransform: "capitalize",
                            "&:hover": { backgroundColor: "rgba(255,255,255,0.1)" },
                          }}
                        >
                          <ListItemText primary={page.label} />
                        </ListItemButton>
                      </ListItem>
                    ))}
                  </List>
                </Box>
              </Drawer>
            </Box>
            <Typography
              variant="h5"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "flex", md: "none" },
                flexGrow: 1,
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
              }}
            >
              <img src={bagarasLogo} alt="Bagara's Indian restaurant logo" width={160} height={120} />
            </Typography>
            {/* Following code is for the desktop menu items */}
            <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, gap: 1 }}>
              {pages.map((page) => (
                <Link
                  key={page.label}
                  href={page.href}
                  onClick={handleCloseNavMenu}
                  sx={{
                    my: 2,
                    color: "#FFFFFF",
                    display: "block",
                    textDecoration: "none",
                    textTransform: "uppercase",
                    fontSize: "0.875rem",
                    px: 1,
                    "&:hover": { color: "#FFD700" },
                  }}
                >
                  {page.label}
                </Link>
              ))}
            </Box>

            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Stack direction="row" spacing={2}>
              <Typography
                  variant="body1"
                  component="p"
                  sx={{
                    color: "white",
                    textAlign: "center",
                  }}
                >
                  <Link href="tel:+16697773303" aria-label="Call Bagara's at (669) 777-3303">
                  <img
                      src={phoneImg}
                      width={30}
                      height={30}
                      alt="Call Bagara's"
                    />
                  </Link>
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  sx={{
                    color: "#20141e",
                    textAlign: "center",
                  }}
                >
                  <Link href="https://www.instagram.com/bagaras_sunnyvale/profilecard/?igsh=MWQ1ZGUxMzBkMA%3D%3D" rel="noopener noreferrer nofollow" aria-label="Bagara's on Instagram">
                    <img
                      src={instaImg}
                      width={30}
                      height={30}
                      alt="Bagara's on Instagram"
                    />
                  </Link>
                </Typography>
                <Typography
                  variant="body1"
                  component="p"
                  sx={{
                    color: "#20141e",
                    textAlign: "center",
                  }}
                >
                  <Link href="https://www.facebook.com/people/Bagaras/61565510966244/" rel="noopener noreferrer nofollow" aria-label="Bagara's on Facebook">
                    <img src={fbImg} width={30} height={30} alt="Bagara's on Facebook" />
                  </Link>
                </Typography>
              </Stack>
            </Box>
          </Toolbar>
        </Container>
        {/* <Card sx={{ display: "flex", justifyContent: "center", padding: 0 }}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Link href="https://maps.app.goo.gl/TX71JhDMXHc4dnvC7">
                <LocationOn sx={{ marginRight: "8px" }} />
              </Link>
              <Link href="https://maps.app.goo.gl/TX71JhDMXHc4dnvC7">
                <Typography component="div" variant="subtitle1">
                  Buy 1 Get 1 Free* (Oct 25 - 27, 2024)
                </Typography>
              </Link>
            </CardContent>
          </Box>
        </Card> */}
        {/* <Card
          sx={{
            display: "flex",
            justifyContent: "center",
            padding: 0,
            background: "orange",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                color: "black",
              }}
            >
              <Typography
                component="div"
                variant="subtitle2"
                sx={{
                  display: "flex",
                  direction: "row",
                  fontSize: "12px",
                  fontStyle: "normal",
                  fontWeight: "bold",
                }}
              >
                Due to high demand, we have limited menu items during the bagara
                launch. We will be adding more items soon.*
              </Typography>
            </CardContent>
          </Box>
        </Card> */}
      </AppBar>
    </div>
  );
}
export default Header;
